import { RichTextElement } from "@redotech/redo-model/forge/marketing-signup-forge-types";
import htmlReactParser from "html-react-parser";
import { memo } from "react";

export const RichText = memo(function RichText({
  element,
}: {
  element: RichTextElement;
}) {
  const containerId = `container-${element.id}`;
  return (
    <>
      <style>
        {`#${containerId} a {
          color: ${element.linkColor};
        }
        .ql-align-right {
          text-align: right;
        }
        .ql-align-center {
          text-align: center;
        }`}
      </style>
      <div
        id={containerId}
        style={{
          color: element.textColor,
          fontSize: element.fontSizePx,
          fontFamily: element.fontFamily,
          border: "none",
          lineHeight: 1.42, // match Quill Editor
        }}
      >
        {htmlReactParser(element.html)}
      </div>
    </>
  );
});
